import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "owner-toolbar"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "identity" }
const _hoisted_4 = {
  key: 1,
  class: "status"
}
const _hoisted_5 = { class: "listing-details" }
const _hoisted_6 = {
  key: 1,
  class: "group-size"
}
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { "aria-hidden": "true" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 3,
  class: "schedule"
}
const _hoisted_13 = { class: "schedule-label" }
const _hoisted_14 = { class: "schedule-slots" }
const _hoisted_15 = { class: "hint" }
const _hoisted_16 = { class: "original-schedule" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 4,
  class: "schedule"
}
const _hoisted_19 = { class: "board-contacts" }
const _hoisted_20 = { class: "contact-platform" }
const _hoisted_21 = ["href"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = ["aria-label", "onClick"]
const _hoisted_24 = {
  key: 5,
  role: "status",
  class: "hint"
}
const _hoisted_25 = {
  key: 6,
  role: "status",
  class: "hint"
}
const _hoisted_26 = {
  key: 7,
  class: "card-actions"
}
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 2,
  class: "hint"
}
const _hoisted_31 = ["disabled"]

import LocaleLink from '@/components/feedback/LocaleLink.vue';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import ContactIcon from './ContactIcon.vue';
import type { BoardAction, BoardListing } from '@avalon/types/player-board';
import { boardInviteUrl } from '@avalon/types/board-contact';
import ReportIcon from './ReportIcon.vue';
import CategoryIcon from './CategoryIcon.vue';
import Avatar from '@/components/user/Avatar.vue';
import { contactLabel, listingState, nextBumpAt } from './board-helpers';
import { dayKeys, formatHour, languageFlags } from './board-display';
import { localWeeklySchedule } from './board-schedule';

export default /*@__PURE__*/_defineComponent({
  __name: 'BoardCard',
  props: {
    listing: {},
    owner: { type: Boolean },
    banned: { type: Boolean },
    busy: { type: Boolean },
    canReport: { type: Boolean },
    now: {}
  },
  emits: ["edit", "action", "report"],
  setup(__props: any) {

const props = __props;

const { t, locale } = useI18n();
const state = computed(() => listingState(props.listing, props.now));
const visitorZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const localSchedule = computed(() =>
  props.listing.scheduleEnabled ? localWeeklySchedule(props.listing, visitorZone, props.now) : null,
);
const scheduleReference = computed(() =>
  localSchedule.value
    ? new Intl.DateTimeFormat(locale.value, { dateStyle: 'medium', timeZone: 'UTC' }).format(
        new Date(`${localSchedule.value.referenceDate}T00:00:00Z`),
      )
    : '',
);
const copied = ref(-1);
const copyFailed = ref(false);
function contactCopyKey(contact: BoardListing['contacts'][number]) {
  if (boardInviteUrl(contact.type, contact.value)) return 'playerBoards.copyLink';
  if (['discord', 'telegram'].includes(contact.type) && !/^\d+$/.test(contact.value.trim()))
    return 'playerBoards.copyUsername';
  return 'playerBoards.copy';
}
const copyNextStep = computed(() => {
  const contact = props.listing.contacts[copied.value];
  return contact && contactCopyKey(contact) === 'playerBoards.copyUsername'
    ? t(`playerBoards.copyNext_${contact.type}`)
    : '';
});
function date(value: string, time = false) {
  return new Intl.DateTimeFormat(locale.value, {
    dateStyle: 'medium',
    ...(time ? { timeStyle: 'short' as const } : {}),
  }).format(new Date(value));
}
async function copy(value: string, index: number) {
  copied.value = -1;
  copyFailed.value = false;
  try {
    await navigator.clipboard.writeText(value);
    copied.value = index;
  } catch {
    copyFailed.value = true;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["board-card", { 'board-card-own': _ctx.owner }])
  }, [
    (_ctx.owner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("strong", null, _toDisplayString(_unref(t)('playerBoards.mine')), 1),
          (!_ctx.listing.moderated && !_ctx.banned)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "edit-button",
                disabled: _ctx.busy,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('edit')))
              }, [
                _cache[5] || (_cache[5] = _createElementVNode("svg", {
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("path", { d: "m15 5 4 4M4 20l4-1L20 7a2.8 2.8 0 0 0-4-4L4 15z" })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(_unref(t)('playerBoards.edit')), 1)
              ], 8, _hoisted_2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("header", null, [
      (_ctx.listing.kind === 'solo')
        ? (_openBlock(), _createBlock(Avatar, {
            key: 0,
            avatarID: _ctx.listing.avatar,
            class: "board-avatar"
          }, null, 8, ["avatarID"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.listing.kind === 'group' ? _ctx.listing.groupName : _ctx.listing.name), 1)
      ]),
      (_ctx.owner)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(t)(`playerBoards.${state.value}`)), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("p", _hoisted_5, [
      _createElementVNode("span", null, [
        _createVNode(CategoryIcon, {
          type: _ctx.listing.experience
        }, null, 8, ["type"]),
        _createTextVNode(_toDisplayString(_unref(t)(`playerBoards.${_ctx.listing.experience}`)), 1)
      ]),
      _createElementVNode("span", null, [
        _createVNode(CategoryIcon, {
          type: _ctx.listing.communication
        }, null, 8, ["type"]),
        _createTextVNode(_toDisplayString(_unref(t)(`playerBoards.${_ctx.listing.communication}`)), 1)
      ])
    ]),
    (_ctx.listing.kind === 'group')
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(t)('playerBoards.groupMembers', { size: _ctx.listing.groupSize })), 1))
      : _createCommentVNode("", true),
    (_ctx.listing.kind === 'group' && _ctx.listing.members?.length)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 2,
          class: "member-roster",
          "aria-label": _unref(t)('giveaway.members')
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listing.members, (member) => {
            return (_openBlock(), _createElementBlock("li", {
              key: member.userID
            }, [
              _createVNode(LocaleLink, {
                to: { name: 'user_stats', params: { uuid: member.userID } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(member.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ], 8, _hoisted_7))
      : _createCommentVNode("", true),
    _createElementVNode("ul", {
      class: "tags",
      "aria-label": _unref(t)('playerBoards.languages')
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listing.languages, (language) => {
        return (_openBlock(), _createElementBlock("li", { key: language }, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(languageFlags)[language]), 1),
          _createTextVNode(" " + _toDisplayString(language === 'other' ? _ctx.listing.otherLanguage : _unref(t)(`playerBoards.language_${language}`)), 1)
        ]))
      }), 128)),
      (_ctx.listing.kind === 'group' && _ctx.listing.beginnerFriendly)
        ? (_openBlock(), _createElementBlock("li", _hoisted_10, _toDisplayString(_unref(t)('playerBoards.beginnerFriendly')), 1))
        : _createCommentVNode("", true),
      (_ctx.listing.canTeach)
        ? (_openBlock(), _createElementBlock("li", _hoisted_11, _toDisplayString(_unref(t)('playerBoards.canTeach')), 1))
        : _createCommentVNode("", true)
    ], 8, _hoisted_8),
    (localSchedule.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)('playerBoards.yourTime', { zone: _unref(visitorZone) })), 1),
          _createElementVNode("ul", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localSchedule.value.slots, (slot, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _createTextVNode(_toDisplayString(_unref(t)(`playerBoards.${_unref(dayKeys)[slot.startDay - 1]}`)) + " ", 1),
                _createElementVNode("strong", null, [
                  _createTextVNode(_toDisplayString(slot.startTime) + "–", 1),
                  (slot.startDay !== slot.endDay)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_unref(t)(`playerBoards.${_unref(dayKeys)[slot.endDay - 1]}`)), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  _createTextVNode(_toDisplayString(slot.endTime), 1)
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)('playerBoards.scheduleReference', { date: scheduleReference.value })), 1),
          _createElementVNode("details", _hoisted_16, [
            _createElementVNode("summary", null, _toDisplayString(_unref(t)('playerBoards.originalSchedule')), 1),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.listing.days.map((day) => _unref(t)(`playerBoards.${_unref(dayKeys)[day - 1]}`)).join(', ')), 1),
              _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("strong", null, _toDisplayString(_unref(formatHour)(_ctx.listing.startHour)) + "–" + _toDisplayString(_unref(formatHour)(_ctx.listing.endHour)), 1),
              _createTextVNode(" · " + _toDisplayString(_ctx.listing.timeZone) + " ", 1),
              (_ctx.listing.endHour < _ctx.listing.startHour)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, " · " + _toDisplayString(_unref(t)('playerBoards.overnight')), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_unref(t)('playerBoards.timeByAgreement')), 1)),
    _createElementVNode("div", _hoisted_19, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listing.contacts, (contact, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: contact.type,
          class: "contact"
        }, [
          _createElementVNode("span", _hoisted_20, [
            _createVNode(ContactIcon, {
              type: contact.type
            }, null, 8, ["type"]),
            _createElementVNode("span", null, _toDisplayString(contact.type === 'qqGroup' ? _unref(t)('playerBoards.qqGroup') : _unref(contactLabel)(contact.type)), 1)
          ]),
          (_ctx.listing.kind === 'group' && _unref(boardInviteUrl)(contact.type, contact.value))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "invite-link",
                href: _unref(boardInviteUrl)(contact.type, contact.value)!,
                target: "_blank",
                rel: "noopener noreferrer nofollow ugc"
              }, _toDisplayString(_unref(t)('playerBoards.joinTeam')) + " ↗", 9, _hoisted_21))
            : (_openBlock(), _createElementBlock("code", _hoisted_22, _toDisplayString(contact.value), 1)),
          _createElementVNode("button", {
            type: "button",
            "aria-label": `${_unref(t)(contactCopyKey(contact))}: ${_unref(contactLabel)(contact.type)}`,
            onClick: ($event: any) => (copy(contact.value, index))
          }, _toDisplayString(_unref(t)(copied.value === index ? 'playerBoards.copied' : contactCopyKey(contact))), 9, _hoisted_23)
        ]))
      }), 128))
    ]),
    (copyNextStep.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(copyNextStep.value), 1))
      : _createCommentVNode("", true),
    (copyFailed.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_unref(t)('playerBoards.copyError')), 1))
      : _createCommentVNode("", true),
    _createElementVNode("footer", null, [
      _createElementVNode("span", null, _toDisplayString(_unref(t)('playerBoards.bumped', { date: date(_ctx.listing.bumpedAt) })), 1)
    ]),
    (_ctx.owner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          (!_ctx.listing.moderated && !_ctx.banned)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (state.value === 'active')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      disabled: _ctx.busy || _ctx.now < _unref(nextBumpAt)(_ctx.listing),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('action', 'bump')))
                    }, _toDisplayString(_unref(t)('playerBoards.bump')), 9, _hoisted_27))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "activate-button",
                      disabled: _ctx.busy,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('action', 'reactivate')))
                    }, _toDisplayString(_unref(t)('playerBoards.reactivate')), 9, _hoisted_28))
              ], 64))
            : _createCommentVNode("", true),
          (state.value === 'active')
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                disabled: _ctx.busy,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('action', 'hide')))
              }, _toDisplayString(_unref(t)('playerBoards.hide')), 9, _hoisted_29))
            : _createCommentVNode("", true),
          (state.value === 'active' && !_ctx.banned && _ctx.now < _unref(nextBumpAt)(_ctx.listing))
            ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_unref(t)('playerBoards.bumpAvailable', { date: date(new Date(_unref(nextBumpAt)(_ctx.listing)).toISOString(), true) })), 1))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.canReport)
        ? (_openBlock(), _createElementBlock("button", {
            key: 8,
            type: "button",
            class: "report-button",
            disabled: _ctx.busy,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('report')))
          }, [
            _createVNode(ReportIcon),
            _createTextVNode(_toDisplayString(_unref(t)('playerBoards.report')), 1)
          ], 8, _hoisted_31))
        : _createCommentVNode("", true)
  ], 2))
}
}

})